import { render, staticRenderFns } from "./BidDocumentationManagement.vue?vue&type=template&id=3c21dfa9&scoped=true"
import script from "./BidDocumentationManagement.vue?vue&type=script&lang=js"
export * from "./BidDocumentationManagement.vue?vue&type=script&lang=js"
import style0 from "./BidDocumentationManagement.vue?vue&type=style&index=0&id=3c21dfa9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21dfa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c21dfa9')) {
      api.createRecord('3c21dfa9', component.options)
    } else {
      api.reload('3c21dfa9', component.options)
    }
    module.hot.accept("./BidDocumentationManagement.vue?vue&type=template&id=3c21dfa9&scoped=true", function () {
      api.rerender('3c21dfa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/BidDocumentationManagement.vue"
export default component.exports